module.exports = __webpack_public_path__ + "static/tree_maroon-f404306bf005f66751f1f4c1fe6508d8.png";